/*------------------------------------------------
// File Name:PDM_BodyCheck_TaoCanType.js
// File Description:PDM_BodyCheck_TaoCanType store方法
// Author:zxl
// Create Time:2023/04/11 11:48:22
//------------------------------------------------*/

import {
    GetPDM_BodyCheck_TaoCanTypeList,
    GetPDM_BodyCheck_TaoCanTypeListByPage,
    GetPDM_BodyCheck_TaoCanTypeEntity,
    CreatePDM_BodyCheck_TaoCanTypeEntity,
    UpdatePDM_BodyCheck_TaoCanTypeEntity,
    DeletePDM_BodyCheck_TaoCanTypeEntity,
} from '@/api/pdm/bodycheckTaocantype'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBodycheckTaocantype = {
    namespaced: true,
    state: {
        PdmBodycheckTaocantypeList: [],
        PdmBodycheckTaocantypeListLoading: false,
        PdmBodycheckTaocantypeEntity: null,
        PdmBodycheckTaocantypeShowDlg: false,
    },
    mutations: {
        setPdmBodycheckTaocantypeList(state, dataList) {
            state.PdmBodycheckTaocantypeList = [...dataList]
        },
        setPdmBodycheckTaocantypeListLoading(state, visible) {
            state.PdmBodycheckTaocantypeListLoading = visible
        },
        setPdmBodycheckTaocantypeShowDlg(state, visible) {
            state.PdmBodycheckTaocantypeShowDlg = visible
        },
        setPdmBodycheckTaocantypeEntity(state, entity) {
            state.PdmBodycheckTaocantypeEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmBodycheckTaocantype({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BodyCheck_TaoCanTypeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocantypeEntity', res.Data)
                        commit('setPdmBodycheckTaocantypeShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmBodycheckTaocantypeEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckTaocantypeListLoading', true)
                GetPDM_BodyCheck_TaoCanTypeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocantypeEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckTaocantypeListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmBodycheckTaocantypeList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckTaocantypeListLoading', true)
                GetPDM_BodyCheck_TaoCanTypeList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocantypeList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckTaocantypeListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmBodycheckTaocantypeListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckTaocantypeListLoading', true)
                GetPDM_BodyCheck_TaoCanTypeListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocantypeList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckTaocantypeListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmBodycheckTaocantype({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BodyCheck_TaoCanTypeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocantypeShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_TaoCanType
        actEditPdmBodycheckTaocantypeData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBodycheckTaocantypeID : entity.PdmBodycheckTaocantypeID
                }
                GetPDM_BodyCheck_TaoCanTypeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBodycheckTaocantypeEntity', res.Data)
                        commit('setPdmBodycheckTaocantypeShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_TaoCanType ,传对象过来
        actEditPdmBodycheckTaocantype({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBodycheckTaocantypeEntity', entity)
                commit('setPdmBodycheckTaocantypeShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BodyCheck_TaoCanType
        actDeletePdmBodycheckTaocantype({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_BodyCheck_TaoCanTypeEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBodycheckTaocantypeShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


